import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { AppointmentsCoursesQuery } from '../../queries/appointments_courses_query';
import { AppointmentsLocationsQuery } from '../../queries/appointments_locations_query';
import { AppointmentsOrganizersQuery1 } from '../../queries/appointments_organizers_query';
import { AppointmentButtonServant } from '../../servants/appointment_button_servant';
import { IAppointmentsTabsConfiguration } from '../../servants/appointments_tabs_configuration';
import { AppointmentUsersourceServant } from '../../servants/appointments_usersource_servant';
import MyAppointmentStateService from '../../services/my_appointment_state_service';
import { ILocation, ILocationCourses, IOrganizer } from '../../types/appt_interfaces';
import { TAppointmentLocationsOrganizersUsersource } from '../../usersources/appointment_location_staff_usersource';

export class AppointmentsLocationStaffController {
  private selectedLocationName: string;
  private selectedCourseName: string;
  private selectedOrganizersNames: Array<string | undefined>;
  private backText: string;
  private isLoading: boolean = true;

  constructor(
    private loadAppointmentsStaffCommand: ICommand,
    private AppointmentsStaffSelectedCommand: ICommand,
    private ngAppointmentsTabsConfiguration: IAppointmentsTabsConfiguration,
    public ngAppointmentLocationsOrganizersUsersource: TAppointmentLocationsOrganizersUsersource,
    public ngAppointmentsLocationsQuery: AppointmentsLocationsQuery,
    public ngAppointmentsOrganizersQuery1: AppointmentsOrganizersQuery1,
    private ngAppointmentsCoursesQuery: AppointmentsCoursesQuery,
    private AppointmentsCoursesSelectedCommand: ICommand,
    private ngAppointmentUsersourceServant: AppointmentUsersourceServant,
    private ngMyAppointmentsStateService: MyAppointmentStateService,
    private loadAppointmentsLocationsCommand: ICommand,
    private ngAppointmentButtonServant: AppointmentButtonServant
  ) {
    this.backText = `Back to ${this.ngMyAppointmentsStateService.currentStep.title}`;
    this.renderAdvisors = this.renderAdvisors.bind(this);
    this.onCourseSelected = this.onCourseSelected.bind(this);
    this.onLocationSelected = this.onLocationSelected.bind(this);
    this.changeOrganizersSelection = this.changeOrganizersSelection.bind(this);
  }

  get getErrorMessageText() {
    return !this.ngAppointmentsOrganizersQuery1.result.hasOrganizers
      ? this.ngAppointmentsOrganizersQuery1.result.errorMessage
      : this.ngAppointmentUsersourceServant.errorBlockedText;
  }

  $onInit() {
    this.ngAppointmentButtonServant.isDisabled = !_4.get(
      this.ngAppointmentsTabsConfiguration.read(),
      '[2].isCompleted',
      false
    );
    if (!this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation.id) {
      this.isLoading = true;
      this.loadAppointmentsLocationsCommand().then(() => {
        this.setValues();
        this.ngMyAppointmentsStateService.stateLoaded();
      });
    } else {
      this.setValues();
      this.ngMyAppointmentsStateService.stateLoaded();
    }
  }

  setValues(): void {
    this.isLoading = false;
    this.selectedLocationName = _4.get(
      this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation,
      'name',
      ''
    );
    this.selectedCourseName = _4.get(this.ngAppointmentLocationsOrganizersUsersource.read().selectedCourse, 'name', '');
    this.selectedOrganizersNames = this.ngAppointmentLocationsOrganizersUsersource
      .read()
      .selectedOrganizers.map((i) => i.name);
  }

  onLocationSelected(selectedLocation: ILocation): void {
    if (this.selectedLocationName !== selectedLocation.name) {
      this.selectedLocationName = selectedLocation.name;
      this.loadAppointmentsStaffCommand(selectedLocation).then(() => {
        if (
          this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation.id &&
          this.ngAppointmentsOrganizersQuery1.result.hasOrganizers
        ) {
          this.ngAppointmentsTabsConfiguration.stepCompleted('2');
        } else {
          this.ngAppointmentsTabsConfiguration.stepInComplete('2');
        }
      });
      this.selectedOrganizersNames = [];
      this.selectedCourseName = '';
    }
  }

  onCourseSelected(selectedCourse: ILocationCourses): void {
    if (this.selectedCourseName !== selectedCourse.name) {
      this.selectedCourseName = selectedCourse.name;
      this.AppointmentsCoursesSelectedCommand(selectedCourse).then(() => {
        if (
          this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation.id &&
          this.ngAppointmentsOrganizersQuery1.result.hasOrganizers &&
          this.ngAppointmentLocationsOrganizersUsersource.read().selectedCourse.id
        ) {
          this.ngAppointmentsTabsConfiguration.stepCompleted('2');
        } else {
          this.ngAppointmentsTabsConfiguration.stepInComplete('2');
        }
      });
      this.selectedOrganizersNames = [];
    }
  }

  changeOrganizersSelection(selectedOrganizer: IOrganizer): void {
    const organizerExists = _4.find(this.ngAppointmentLocationsOrganizersUsersource.read().selectedOrganizers, {
      id: selectedOrganizer.id
    });
    let selectedOrganizers: IOrganizer[] = [];
    const allSelectedOrganizers = this.ngAppointmentLocationsOrganizersUsersource.read().selectedOrganizers;
    if (!!organizerExists) {
      _4.remove(allSelectedOrganizers, (org: IOrganizer) => {
        return org.id === selectedOrganizer.id;
      });
      _4.remove(this.selectedOrganizersNames, (name: string) => selectedOrganizer.name === name);
      selectedOrganizers = allSelectedOrganizers;
    } else if (!!selectedOrganizer) {
      this.selectedOrganizersNames.push(selectedOrganizer.name);
      this.ngAppointmentLocationsOrganizersUsersource.set('selectedOrganizers', [
        ...allSelectedOrganizers,
        selectedOrganizer
      ]);
      selectedOrganizers = this.ngAppointmentLocationsOrganizersUsersource.read().selectedOrganizers;
    }
    this.AppointmentsStaffSelectedCommand(selectedOrganizers).then(() => {
      this.ngAppointmentsTabsConfiguration.stepCompleted('2');
    });
  }

  renderAdvisors(item: IOrganizer): string {
    return `${item.name} ${item.advisorLabel}`;
  }
}

angular
  .module('capability-ng-appointments')
  .controller('ngAppointmentsLocationStaffController', AppointmentsLocationStaffController);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/views/location_staff/appointments_location_staff.ts